import React from "react";
import iconBrand from "../../images/icon-brand-recognition.svg";
import iconRecords from "../../images/icon-detailed-records.svg";
import iconCustom from "../../images/icon-fully-customizable.svg";

function Statistics() {
    return (
        <section className="stats-section section-padding">
            <h2>Advanced Statistics</h2>
            <p>
                Track how your links are performing across the web with our
                advanced statistics dashboard.
            </p>

            <div className="stats">
                <div className="stats__category">
                    <div className="stats__icon-wrapper">
                        <img src={iconBrand} alt="Icon of a graph" />
                    </div>
                    <h3>Brand Recognition</h3>
                    <p>
                        Boost your brand recognition with each click. Generic
                        links don’t mean a thing. Branded links help instil
                        confidence in your content.
                    </p>
                </div>

                <div className="stats__category">
                    <div className="stats__icon-wrapper">
                        <img src={iconRecords} alt="Icon of a speedometer" />
                    </div>
                    <h3>Detailed Records</h3>
                    <p>
                        Gain insights into who is clicking your links. Knowing
                        when and where people engage with your content helps
                        inform better decisions.
                    </p>
                </div>

                <div className="stats__category">
                    <div className="stats__icon-wrapper">
                        <img
                            src={iconCustom}
                            alt="Icon of a marker, a pen, and a paintbrush"
                        />
                    </div>
                    <h3>Fully Customizable</h3>
                    <p>
                        Improve brand awareness and content discoverability
                        through customizable links, supercharging audience
                        engagement.
                    </p>
                </div>
            </div>
        </section>
    );
}

export default Statistics;
